import { h, Host } from "@stencil/core";
/**
 * @slot (default) - Content of the sidebar
 */
export class AppHeader {
    constructor() {
        this.baseClass = "uxc-app-sidebar-notifications";
        this.opened = false;
        this.side = "right";
        this.alignHeader = true;
        this.alignFooter = false;
    }
    componentDidLoad() {
        this.appSidebarNotificationsEvent.emit();
    }
    render() {
        const { baseClass, opened, side, alignHeader, alignFooter } = this;
        return (h(Host, { key: 'ad20840490519e369a864f29bdea7ae22c67a7c6', class: {
                [`${baseClass}`]: true
            } }, h("uic-sidebar", { key: 'deaceb498203c8151f5585ad1aa744e8d0bea376', opened: opened, side: side, alignHeader: alignHeader, alignFooter: alignFooter }, h("div", { key: 'd8c069e1e8c1e3316f59e3ffc9a268c7e84acd7d', class: `${baseClass}__inner` }, h("slot", { key: '434a213907d52304bfa977b25665bc99db9d6c6f' })))));
    }
    static get is() { return "uxc-app-sidebar-notifications"; }
    static get originalStyleUrls() {
        return {
            "$": ["app-sidebar-notifications.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["app-sidebar-notifications.css"]
        };
    }
    static get properties() {
        return {
            "opened": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Flag that indicates if the app sidebar notification is opened or not"
                },
                "attribute": "opened",
                "reflect": false,
                "defaultValue": "false"
            },
            "side": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"left\" | \"right\"",
                    "resolved": "\"left\" | \"right\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "On which side should the sidebar be positioned"
                },
                "attribute": "side",
                "reflect": false,
                "defaultValue": "\"right\""
            },
            "alignHeader": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Flag that indicates if the sidebar top should be aligned with a header"
                },
                "attribute": "align-header",
                "reflect": false,
                "defaultValue": "true"
            },
            "alignFooter": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Flag that indicates if the sidebar bottom should be aligned with a footer"
                },
                "attribute": "align-footer",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get events() {
        return [{
                "method": "appSidebarNotificationsEvent",
                "name": "uicAppSidebarNotifications",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emitted when the sidebar is loaded. This event informs the app header that\nthe notification bell icon controls the opened state of the sidebar."
                },
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "element"; }
}
//# sourceMappingURL=app-sidebar-notifications.js.map
